import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/api";
import { useI18n } from "@/i18n";

export default function NewsletterActionPage({ action }) {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");

  useEffect(() => {
    const token = params.get("token") || "";
    api.get(`/newsletter/${action}`, { params: { token } })
      .then(() => setState("ok"))
      .catch((e) => setState(e?.response?.status === 410 ? "expired" : "invalid"));
  }, [action, params, api]);

  const key = state === "loading" ? null : `nl.${action}_${state}`;
  return (
    <div className="flex flex-col items-center gap-4 pt-24 text-center" data-testid={`newsletter-${action}-page`}>
      <p className="text-sm text-slate-300" data-testid="newsletter-action-result">
        {state === "loading" ? t("common.loading") : t(key)}
      </p>
      {state !== "loading" && (
        <Link to="/" className="font-mono2 text-[11px] uppercase tracking-wider text-[#00FF87] hover:underline">
          Rookie Radar
        </Link>
      )}
    </div>
  );
}
